// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@page{margin:17mm 17mm 17mm 17mm;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;size:A4}.print-container[data-v-75594f1f]{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
